import { registry } from '@cian/mf-registry/browser';

export async function ensureMicrofrontend(name: string) {
  const api = await registry().microfrontendStrict(name).api()?.ensure();

  return api;
}
